import {ENV_PROD, ENV_LOCAL, ENV_DEV} from '../constants/env';

let host = 'bad-server-configuration';
const apiVersion = 'v2';

if (process.env.REACT_APP_ENV) {
    if (process.env.REACT_APP_ENV === ENV_LOCAL) {
//       host = 'https://10.1.0.176:8000/app_dev.php';
        host = 'https://api-master.openium.fr';
    } else if (process.env.REACT_APP_ENV === ENV_DEV) {
        host = 'https://api-dev.openium.fr';
    } else if (process.env.REACT_APP_ENV === ENV_PROD) {
        host = 'https://api.openium.fr';
    }
} else if (process.env.NODE_ENV === ENV_PROD) {
    host = 'https://api.openium.fr';
}

export default `${host}/api/${apiVersion}/admin`;



// WEBPACK FOOTER //
// src/constants/api.js